import { render, staticRenderFns } from "./RadetIndex.vue?vue&type=template&id=f44b5bc2&"
import script from "./RadetIndex.vue?vue&type=script&lang=js&"
export * from "./RadetIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports